import { render, staticRenderFns } from "./MultipleChoicePoll.vue?vue&type=template&id=48913861&scoped=true&"
import script from "./MultipleChoicePoll.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicePoll.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoicePoll.vue?vue&type=style&index=0&id=48913861&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48913861",
  null
  
)

export default component.exports